export class Subscriber {

    private readonly _subscriptions: any[] = [];

    public subscribe<T extends (...args: any[]) => void>(message: any, func: T): any {
        const t = PubSub.subscribe(message, func);
        this._subscriptions.push(t);
        return t;
    }

    public destroy() {
        for (const subscription of this._subscriptions) {
            PubSub.unsubscribe(subscription);
        }
    }
}
